import "!../../node_modules/mini-css-extract-plugin/dist/loader.js?{}!css-loader?{\"modules\":false,\"url\":false}!./strip.treat.l7Mgof-.css";
export var stripStyles = {inner:'_3jL5l',bySize:{md:'_19AOZ',sm:'_2Am0y',xs:'lZql6'}};